import React from 'react';
import PartnersSection from '../components/PartnersSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/Partners-banner.jpeg";
import SeoContentSection from "../components/SeoContentSection";

const Partner = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="NIECCE Teacher Training"
  subtitle="Collaborating with leading organizations to enhance educational excellence"
 />
 <PartnersSection />
 <SeoContentSection title="NIECCE Teacher Training Partners and Collaborations">
   <p>
     NIECCE works with education partners, schools, and authorised training centers to make quality teacher certification accessible to more learners. These collaborations strengthen our teaching course delivery and connect students with practical classroom environments.
   </p>
   <p>
     Our partners support Montessori teacher training courses, nursery education, and pre-primary learning through workshops, resources, and professional engagement. Together, we help aspiring teachers develop skills that are relevant to modern schools and early learning centers.
   </p>
 </SeoContentSection>
    </>
  );
};

export default Partner;
